import { z } from 'zod';

export const PaymentDetailsZod = z.object({
    annualFee: z.number(),
    clientSecret: z.string(),
    customerId: z.string().optional(),
    discountAmount: z.number().optional(),
    name: z.string(),
    oneTimeFee: z.number().optional(),
    planCode: z.string(),
    planName: z.string(),
    price: z.number(),
    promocode: z.array(z.string()).optional(),
    qInstanceId: z.number().optional(),
    totalAmount: z.number(),
    savedCard: z.object({ id: z.string(), card: z.object({ brand: z.string(), last4: z.string() }) }).optional(),
    paymentIntentId: z.string().optional(),
    setupIntentId: z.string().optional(),
    promocodeExpired: z.boolean().optional(),
});
export const PaymentDetailsResponseZod = z.union([z.object({}), PaymentDetailsZod]);

export type PaymentDetails = z.infer<typeof PaymentDetailsZod>;
export type PaymentDetailsResponse = z.infer<typeof PaymentDetailsResponseZod>;
